import { jsx as _jsx } from "react/jsx-runtime";
import { clearFilter, FilmFilterKey, FilterType } from '@vista/omnichannel-components-domain';
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { useContext } from 'react';
import { useI18n } from '../../../context/occ/hooks/use-i18n';
import { Message } from '../../../subcomponents/message/message';
import { FilmListContextInstance } from '../types/context';
export var FilmListMessageType;
(function (FilmListMessageType) {
    FilmListMessageType["NoFilms"] = "NoFilms";
    FilmListMessageType["NoFilmsForFilterOption"] = "NoFilmsForFilterOption";
    FilmListMessageType["NoFilmsForMultipleFilters"] = "NoFilmsForMultipleFilters";
    FilmListMessageType["FailedToLoadData"] = "FailedToLoadData";
})(FilmListMessageType || (FilmListMessageType = {}));
const b = bemClassBuilder('v-film-list-message');
export const FilmListMessage = observer(({ messageType, filterId, label }) => {
    const i18n = useI18n();
    const includeClearFilterButton = [
        FilmListMessageType.NoFilmsForMultipleFilters,
        FilmListMessageType.NoFilmsForFilterOption
    ].includes(messageType);
    const { displayText, assets } = useContext(FilmListContextInstance);
    const handleClearButtonClicked = () => {
        if (!filterId)
            return;
        clearFilter({ id: filterId, type: FilterType.Film, keys: Object.values(FilmFilterKey) });
    };
    return (_jsx(Message, Object.assign({}, getFilmListMessageProps(messageType, assets, displayText, i18n, label), { className: b.block() }, { children: includeClearFilterButton && (_jsx("p", Object.assign({ className: b.element('clear-button'), onClick: handleClearButtonClicked }, { children: displayText.noFilmsForFilterClearButtonLabel }))) })));
});
FilmListMessage.displayName = 'FilmListMessage';
const getFilmListMessageProps = (messageType, assets, displayText, i18n, label) => {
    switch (messageType) {
        case FilmListMessageType.NoFilms:
            return { iconName: assets.noFilmsIconName, title: displayText.noFilmsTitle };
        case FilmListMessageType.NoFilmsForFilterOption:
            return {
                iconName: assets.noFilmsForFilterOptionIconName,
                title: getFormattedMessage(displayText.noFilmsForFilterOptionTitle, i18n, label),
                description: getFormattedMessage(displayText.noFilmsForFilterOptionMessage, i18n, label)
            };
        case FilmListMessageType.NoFilmsForMultipleFilters:
            return {
                iconName: assets.noFilmsForMultipleFiltersIconName,
                description: displayText.noFilmsForMultipleFiltersMessage
            };
        case FilmListMessageType.FailedToLoadData:
            return {
                iconName: assets.failedToLoadDataIconName,
                title: displayText.failedToLoadDataTitle,
                description: displayText.failedToLoadDataMessage
            };
        default:
            return {
                iconName: assets.failedToLoadDataIconName
            };
    }
};
const getFormattedMessage = (template, i18n, label) => {
    return i18n.template(template, { label });
};
